<template>
  <div class="prod-container" v-loading="loading == -1">
    <md-breadcrumb :dataSource="cateParents" @breadcrumbClick="breadcrumbClick"></md-breadcrumb>

    <div class="page-data">
      <div class="sort-view">
        <span class="sort-btn" :class="sort === 1 ? 'active' : ''" @click="sortChange(1)">默认</span>
        <span class="sort-hr">|</span>
        <span class="sort-btn" :class="sort === 2 ? 'active' : ''" @click="sortChange(4)">最新发布</span>
        <span class="sort-hr">|</span>
        <span class="sort-btn" :class="sort === 4 ? 'active' : ''" @click="sortChange(4)">浏览量</span>
        <span class="sort-hr">|</span>
        <span class="sort-btn" :class="sort === 6 ? 'active' : ''" @click="sortChange(6)">下载量</span>
      </div>
      <div>共计<span class="total-tip">{{total}}</span>个产品</div>
    </div>

    <div class="prod-list-con" v-if="prods.length > 0">
       <div class="prod-list-block" v-for="prod in prods" :key="prod.ProdID">
      <card-list :data="prod" :showComp="false" type="prod">
        <template #footer>
          <div class="product-data-copy" v-if="$route.query.source === 'admin'">
            <el-button size="small" @click.stop="dataCopy(prod.ProdID)">复制产品ID</el-button>
          </div>
        </template>
      </card-list>
      </div>
      <div class="list-card-empty" v-for="item of 20" :key="`key_${item}`"></div>
    </div>
    <el-empty description="暂无产品" v-else></el-empty>

    <div class="pagination">
      <md-page :page="page" :total="total" :pageSize="pageSize" @pagecallback="pageChanged"></md-page>
    </div>
  </div>
</template>

<script>
  import copy from "copy-to-clipboard";
  import {MessageBox as ElMessageBox} from "element-ui";
  //引入服务
  import {ProductService,TodaySearchService,Message} from "@/service";
  //引入组件
  import ProdIcon from "@/components/icon/prod-icon.vue";
  import MdPage from '@/components/md-page.vue'; 
  import VipLevelIcon from '@/components/icon/vip-level-icon.vue';
  import CardList from "@/components/card-list.vue";
  import MdBreadcrumb from "@/components/md-breadcrumb/md-breadcrumb.vue";

  export default {
    name: "ProdList",
    props: {
      defaultNode: { default: [] },
      compVipLevel: { default: 0 },
    },
    components: {
      ProdIcon,
      MdPage,
      VipLevelIcon,
      CardList,
      MdBreadcrumb
    },
    data() {
      return {
        prods: "", //产品列表
        dirId: 0,
        sort: 1,
        page: 1,
        pageSize: 50,
        total: 0,
        loading: 0, //状态  -1加载中 0 未加载  1 加载完成
        searchValue:"",
        cateParents: this.defaultNode,
      };
    },
    mounted() {
      // this.loadProdList();
    },
    methods: {
      dataCopy(value) {
        if (copy(value)) {
          Message.success(value + "：复制成功");
        } else {
          Message.error(value + "：复制失败");
        }
      },
      async loadProdList() {
        //加载产品列表
        this.loading = -1;
        TodaySearchService.prodSearch({
          page: this.page,
          pageSize: this.pageSize,
          compId: this.$route.params.compid,
          dirId: this.dirId,
          sort: this.sort,
        }).then(res => {
          this.prods = res.data.list.map(item => {
            let newItem = {};
            Object.keys(item).forEach(v => {
              newItem[v.slice(0, 1).toUpperCase() + v.slice(1)] = item[v];
            })
            newItem.DirID = this.dirId;
            newItem.ProdID = newItem.ProdId;
            return newItem;
          });
          this.total = res.data.count || 0;
          this.loading = 1;
        });
      },
      del(prod) {
        ElMessageBox.confirm('您确定要从我的收藏中删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          ProdFavoriteService.del(prod.FavoriteID, this.dirId).then(res => {
            if (res) {
              if (this.prods.length == 1 && this.page != 1) {
                this.page--;
              }
              this.loadProdList();
            }
          })
        }).catch(() => {
        });

      },

      sortChange(sort) {
        this.sort = sort;
        this.loadProdList();
      },

      dirChanged(dirId, cateParents = []) {
        this.page = 1;
        this.dirId = dirId;
        this.cateParents = cateParents.reverse();
        this.loadProdList();
      },
      pageChanged(param) {
        this.page = param.page;
        this.loadProdList();
      },
      breadcrumbClick(value) {
        this.$parent.$refs.catalogTreeRef.select(`list_${value.DirID}`);
      },
    }
  };
</script>

<style lang="less" scoped>
.prod-list-block {
  min-width: 150px;
  max-width: 180px;
  margin: 0 5px 10px 5px;
  flex: 1;
  border: 1px solid #d6d6d6;
  position: relative;
  &>.list-card{
    margin: 0;
    position: initial;
    height: 100%;
    border: 0 none;
    min-width: 100%;
  }
}
.product-data-copy{
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.2);
  display: flex;
  justify-content: center;
  align-items: center;
}
.page-data{
  padding: 10px 0;
  font-size: 14px;
  color: @text-color-call-out;
  display: flex;
  justify-content: space-between;
  .total-tip{
    color: @a-color-active;
  }
}
.prod-list-con{
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.pagination{
  position: sticky;
  left: 0;
  bottom: 0;
}
.prod-container{
  margin-left: 10px;
  flex: 1;
}
.sort-view{
  color: @text-color-call-out;
  .sort-hr{
    color: #E7E9ED;
    padding: 0 14px;
  }
  .sort-btn{
    cursor: pointer;
  }
  .sort-btn.active{
    color: @a-color-active;
  }
}
</style>
